export default __webpack_public_path__ + "static/media/event.5414a2b1.png";